<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">


<!--sidebar-->
<ItemSidebar 
:name="$store.state.questions.question.name.slice(0, 30)+'...'" 
:brand="$store.state.questions.question.brand"
:project="$store.state.questions.question.project"
:flow="$store.state.questions.question.flow"
:questionlist="$store.state.questions.question.questionlist"
></ItemSidebar>
<!--sidebar-->






<div class="col-12 md:col-10">
<div class="content_card_content pb-8">
<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>




</div>
 </div> 
</template>

<script>
export default {

  name: 'Question',

  data () {
    return {
      item:null,
      tabs: [
      ],

    }
  },
  mounted()
  {
    
    this.getData()
    this.checkTabName(this.tabs)
  },
  computed:{
  	qustiontype()
  	{
  		if(this.$store.state.questions.question)
  		{
  			return this.$store.state.questions.question.type
  		}
  	},
  	classeslength()
  	{
  		if(this.$store.state.questions.question)
  		{
  			return this.$store.state.questions.question.inputfieldclasses
  		}
  		
  	},
  },
  watch:{
  	qustiontype(newval,oldval)
  	{
  		
  		this.arrangeTabMenu()
  	},
  	classeslength(newval,oldval)
  	{
  		
  		this.arrangeTabMenu()
  	}
  },
  methods:{
  	async getData()
    {
        let item = await this.generalApiGet("questionlists/inputfield/"+this.$route.params.id)
        console.log(item)
        
        await this.$store.dispatch('questions/setQuestion',item) 
        this.item = await item
        await this.arrangeTabMenu()
    },
    arrangeTabMenu()
    {
    	let qu = this.$store.state.questions.question
    	if(qu.inputfieldclasses.length)
    	{

    	}

    	if(qu.type=="multiselect" || qu.type=="select" || qu.type=="boolean" || qu.type=="listselect" )
    	{
    		if(qu.questionlist.type=="same_question_pattern")
    		{
    			this.tabs = [
		          {
		              title: 'soru',
		              icon: 'list',
		              route: 'general',
		          },
		          {
		              title: 'ceviriler',
		              icon: 'info-circle',
		              route: 'translations',
		          },
		      ]
    		}
    		else
    		{
    			this.tabs = [
		          {
		              title: 'soru',
		              icon: 'list',
		              route: 'general',
		          },
		          {
		              title: 'ceviriler',
		              icon: 'info-circle',
		              route: 'translations',
		          },
		          {
		              title: 'secenekler',
		              icon: 'list',
		              route: 'options',
		          }
		      ]
    		}
    		
    	}

    	if(qu.type=="boolean" )
    	{
    		this.tabs = [
	          {
	              title: 'soru',
	              icon: 'list',
	              route: 'general',
	          },
	          {
	              title: 'ceviriler',
	              icon: 'info-circle',
	              route: 'translations',
	          },
	          
	          /*
	          {
	              title: 'kosullar',
	              icon: 'exclamation-circle',
	              route: 'conditions',
	          }*/
	          {
	              title: 'secenekler',
	              icon: 'list',
	              route: 'boolean_options',
	          }
	      ]
    	}
    	if(qu.type=="text" || qu.type=="longtext"||qu.type=="number"||qu.type=="readonlytext"|| qu.type=="location")
    	{
    		this.tabs = [
	          {
	              title: 'soru',
	              icon: 'list',
	              route: 'general',
	          },
	          {
	              title: 'ceviriler',
	              icon: 'info-circle',
	              route: 'translations',
	          },
	      ]
    	}
    	if(qu.type=="columns" || qu.type=="listinput" )
    	{
    		if(qu.questionlist.type=="same_question_pattern")
    		{
    			this.tabs = [
		          {
		              title: 'soru',
		              icon: 'list',
		              route: 'general',
		          },
		          {
		              title: 'ceviriler',
		              icon: 'info-circle',
		              route: 'translations',
		          },
		          
		      ]
    		}
    		else
    		{
    			this.tabs = [
		          {
		              title: 'soru',
		              icon: 'list',
		              route: 'general',
		          },
		          {
		              title: 'ceviriler',
		              icon: 'info-circle',
		              route: 'translations',
		          },
		          /*
		          {
		              title: 'kosullar',
		              icon: 'exclamation-circle',
		              route: 'conditions',
		          }*/
		          {
		              title: 'sutunlar',
		              icon: 'table',
		              route: 'columns',
		          }
		      ]
    		}
    		if(qu.inputfieldclasses.length)
	    	{
	    		let the_obj = {
	    			title:"sinif_faktorleri",
	    			icon:"tag",
	    			route:"class_factors"
	    		}
	    		this.tabs.push(the_obj)

	    	}
    		

    	}
    	for(let tab of this.tabs)
        {
          tab.route =  "/"+this.$store.state.auth.user.uuid+"/question/"+this.$route.params.id+"/"+tab.route
        }
    }
  }
};
</script>

<style lang="css" scoped>
</style>